// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-zzbdtjcx-jxZzbdtjcx-index-main_right_content-26_F2","table":"components-tjcx-zzbdtjcx-jxZzbdtjcx-index-table-1Z-fm"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/zzbdtjcx/jxZzbdtjcx/index.css
// module id = 827
// module chunks = 0